/* tslint:disable:variable-name */
/* eslint-disable @typescript-eslint/camelcase */

export const white = '#ffffff';
export const background_800 = '#000000';
export const background_500 = '#364049';
export const background_300 = '#364049';
export const background_200 = '#364049';
export const background_150 = '#c0cad5';
export const background_100 = '#c0cad5';
export const background_50 = '#f4f6f8';
export const background_20 = '#f4f6f8';
export const text_800 = '#001833';
export const text_500 = '#4f6f8f';
export const text_300 = '#c0cad5';
export const text_100 = '#f4f6f8';
export const text_000 = '#ffffff';
export const red_500 = '#800800';
export const red_400 = '#800800';
export const red_300 = '#c00c00';
export const red_200 = '#fbebeb';
export const red_100 = '#fbebeb';
export const red_50 = '#fbebeb';
export const orange_500 = '#f06f20';
export const orange_400 = '#f06f20';
export const orange_300 = '#f68013';
export const orange_200 = '#fef2e7';
export const orange_100 = '#fef2e7';
export const orange_50 = '#fef2e7';
export const green_500 = '#006600';
export const green_400 = '#006600';
export const green_300 = '#00aa00';
export const green_200 = '#ecf7ec';
export const green_100 = '#ecf7ec';
export const green_50 = '#ecf7ec';
export const indigo_500 = '#7700bb';
export const indigo_400 = '#7700bb';
export const indigo_300 = '#7700bb';
export const indigo_200 = '#f5ebfa';
export const indigo_100 = '#f5ebfa';
export const indigo_50 = '#f5ebfa';
export const purple_500 = '#7700bb';
export const purple_400 = '#7700bb';
export const purple_300 = '#7700bb';
export const purple_200 = '#f5ebfa';
export const purple_100 = '#f5ebfa';
export const purple_50 = '#f5ebfa';
export const blue_500 = '#004499';
export const blue_400 = '#004499';
export const blue_300 = '#00bfff'; // deep-sky-blue
export const blue_200 = '#e8f2ff';
export const blue_100 = '#e8f2ff';
export const blue_50 = '#e8f2ff';
export const yellow_500 = '#fedc2a';
export const yellow_400 = '#fedc2a';
export const yellow_300 = '#fedc2a';
export const yellow_200 = '#fff3c0';
export const yellow_100 = '#fff3c0';
export const yellow_50 = '#fff3c0';
export const nha_sakura_500 = '#fe3e81';
export const nha_sakura_400 = '#fe3e81';
export const nha_sakura_300 = '#fe3e81';
export const nha_sakura_200 = '#fe3e81';
export const nha_sakura_100 = '#fe3e81';
export const nha_sakura_50 = '#fe3e81';
export const ocean_500 = '#004499';
export const ocean_400 = '#004499';
export const ocean_300 = '#007aff';
export const ocean_200 = '#e8f2ff';
export const ocean_100 = '#e8f2ff';
export const ocean_50 = '#e8f2ff';
export const nha_green_500 = '#006600';
export const nha_green_300 = '#00aa00';
export const nha_green_50 = '#ecf7ec';
export const flight_blue_500 = '#004499';
export const flight_blue_400 = '#004499';
export const flight_blue_300 = '#007aff';
export const flight_blue_200 = '#e8f2ff';
export const flight_blue_100 = '#e8f2ff';
export const flight_blue_50 = '#e8f2ff';
export const alpha_black_80 = 'rgba(0, 0, 0, 0.8)';
export const alpha_black_50 = 'rgba(0, 0, 0, 0.5)';
export const alpha_black_40 = 'rgba(0, 0, 0, 0.4)';
export const alpha_black_30 = 'rgba(0, 0, 0, 0.3)';
export const alpha_black_15 = 'rgba(0, 0, 0, 0.15)';
export const alpha_black_10 = 'rgba(0, 0, 0, 0.1)';
export const alpha_white_80 = 'rgba(255, 255, 255, 0.8)';
export const alpha_white_50 = 'rgba(255, 255, 255, 0.5)';
export const alpha_white_30 = 'rgba(255, 255, 255, 0.3)';
export const alpha_white_20 = 'rgba(255, 255, 255, 0.2)';
